// USEKO — Translations for TR, EN, AR
// Keep keys stable; add new keys at the bottom of each section.

export const translations = {
  tr: {
    // Meta
    lang_name: "Türkçe",
    lang_code: "tr",
    dir: "ltr",

    // Global
    org_short: "USEKO",
    org_full: "Uluslararası Sürdürülebilir Kalkınma Ekonomik İşbirliği ve Organizasyon Derneği",
    slogan: "Geleceği Birlikte İnşa Ediyoruz",
    org_hq: "İstanbul, Türkiye",

    // Nav
    nav_home: "Anasayfa",
    nav_about: "Kurumsal",
    nav_about_us: "Hakkımızda",
    nav_mission: "Misyon & Vizyon",
    nav_principles: "Temel İlkeler",
    nav_documents: "Tüzük ve Belgeler",
    nav_president: "Başkanın Mesajı",
    nav_board: "Yönetim Kurulu",
    nav_activities: "Faaliyet Alanları",
    nav_projects: "Projeler",
    nav_syria: "Uluslararası Program",
    nav_membership: "Üyelik",
    nav_support: "Destek Ol",
    nav_volunteer: "Gönüllü Ol",
    nav_partnership: "İş Birliği",
    nav_news: "Haberler",
    nav_announcements: "Duyurular",
    nav_contact: "İletişim",
    nav_admin: "Yönetim",
    nav_chairmanships: "Başkanlıklar",

    // New menu items
    nav_why_useko: "Neden USEKO?",
    nav_president_message: "Başkanın Mesajı",
    nav_organization: "Organizasyon Yapısı",
    nav_programs: "Programlar",
    nav_press_releases: "Basın Bültenleri",
    nav_contact_info: "İletişim Bilgileri",
    nav_contact_form: "İletişim Formu",
    nav_social_media: "Sosyal Medya",
    nav_area_merged_industry: "Sanayi, Teknoloji, Savunma, Ekonomi ve Ticaret",
    nav_area_education_academic: "Eğitim ve Akademi",
    nav_area_research_publishing: "Araştırma ve Yayıncılık",

    // Programs
    program_intl_cooperation: "Uluslararası İş Birliği Programları",
    program_trade_delegations: "Ticaret Heyetleri",
    program_academic_partnerships: "Akademik İş Birlikleri",
    program_youth: "Gençlik Programları",
    program_women_entrepreneurship: "Kadın Girişimciliği Programı",
    program_volunteering: "Gönüllülük Programı",
    program_leadership: "Liderlik Programı",
    program_social_impact: "Sosyal Etki Programları",

    content_coming_soon: "Bu bölümün detaylı içeriği kısa süre içinde eklenecektir. Ek bilgi ve iş birliği talepleri için lütfen İletişim sayfamızdan bize ulaşın.",

    // Chairmanships
    chair_overline: "Yapılanma",
    chair_home_title: "Başkanlıklarımız",
    chair_home_desc: "Faaliyetlerimizin etkin yürütülmesi için tüzük çerçevesinde sektörel ve fonksiyonel başkanlıklar kurulmuştur. Her başkanlık, ilgili faaliyet alanının koordinasyonu altında strateji geliştirir ve projeler yürütür.",
    chair_type_sektorel: "Sektörel Başkanlık",
    chair_type_fonksiyonel: "Fonksiyonel Başkanlık",
    chair_type_sektorel_plural: "Sektörel Başkanlıklar",
    chair_type_fonksiyonel_plural: "Fonksiyonel Başkanlıklar",
    chair_intro_desc: "USEKO Yönetim Kurulu bünyesinde faaliyet gösteren başkanlıklarımızdan biridir.",
    chair_scope_heading: "Görev Alanı",
    chair_scope_body: "Bu başkanlık, {parent} faaliyet alanı kapsamında görev yapmaktadır. Yönetim Kurulu tarafından belirlenen görev tanımları çerçevesinde ilgili sektör/fonksiyonda strateji geliştirir, projeler yürütür ve paydaşlarla iş birliği sağlar.",
    chair_activities_heading: "Faaliyetlerimiz",
    chair_bullet_1: "Strateji, yol haritası ve politika geliştirme",
    chair_bullet_2: "Ulusal ve uluslararası paydaşlarla iş birliği",
    chair_bullet_3: "Araştırma, rapor ve öneri hazırlığı",
    chair_bullet_4: "Proje geliştirme ve uygulama",
    chair_bullet_5: "Kapasite geliştirme ve bilgi paylaşımı",
    chair_parent_overline: "Bağlı Olduğu Faaliyet Alanı",

    // Home — Hero tagline + Nedir/Neden USEKO
    hero_tagline: "Sürdürülebilir kalkınma, ekonomik diplomasi, insani dayanışma ve uluslararası iş birliğinde küresel strateji platformu",
    what_useko_overline: "Tanıtım",
    what_useko_title: "USEKO Nedir?",
    what_useko_body: "USEKO; ekonomik kalkınma, ticari diplomasi ve uluslararası iş birliği alanlarında faaliyet gösteren, Türkiye merkezli uluslararası bir sivil toplum kuruluşudur. Kamu, özel sektör, akademi ve uluslararası kuruluşlar arasında stratejik ortaklıklar geliştirerek sürdürülebilir kalkınmaya ve küresel iş birliğine katkı sunmayı amaçlamaktadır.",
    why_useko_overline: "Yaklaşımımız",
    why_useko_title: "Neden USEKO?",
    why_useko_body: "Küresel ölçekte sürdürülebilir kalkınma; güçlü ortaklıklar, güvene dayalı iş birlikleri ve ortak akıl gerektirmektedir. USEKO, farklı sektörleri ve ülkeleri ortak hedefler etrafında buluşturarak ekonomik, sosyal ve kültürel değer üreten sürdürülebilir iş birliği modelleri geliştirmektedir.",

    // Buttons
    btn_join: "Üye Ol",
    btn_projects: "Projelerimizi İncele",
    btn_volunteer: "Gönüllü Ol",
    btn_partnership: "İş Birliği Başvurusu",
    btn_learn_more: "Detaylı İncele",
    btn_read_more: "Devamını Oku",
    btn_view_program: "Programı İncele",
    btn_send: "Gönder",
    btn_submit: "Başvuruyu Gönder",
    btn_all: "Tümünü Gör",

    // Hero
    hero_title: "Geleceği Birlikte İnşa Ediyoruz",
    hero_sub: "USEKO; Türkiye'nin ekonomik, teknolojik ve sosyal kalkınmasına katkı sağlar, uluslararası iş birlikleri ve ekonomik diplomasi ile daha güçlü toplumlar için köprüler kurar.",

    // About
    home_mission_overline: "Misyonumuz",
    home_mission_title: "Kalıcı Fayda İçin",
    home_mission_body: "Ulusal ve uluslararası düzeyde ekonomik kalkınmayı destekleyen, ticari ve stratejik iş birliklerini güçlendiren, bilgi ve deneyim paylaşımını teşvik eden, sürdürülebilir ve kapsayıcı ortaklık modelleri geliştirmek.",
    home_vision_overline: "Vizyonumuz",
    home_vision_title: "Uluslararası Ölçekte",
    home_vision_body: "Türkiye'nin ekonomik, ticari ve diplomatik kapasitesinin uluslararası ölçekte daha güçlü temsil edilmesine katkı sağlayan, güvenilir ve saygın bir küresel iş birliği platformu olmak.",
    what_is_useko: "USEKO Nedir?",
    what_is_useko_desc: "USEKO; Türkiye'nin ekonomik, ticari, teknolojik, bilimsel, kültürel ve sosyal kalkınmasına katkı sağlamak, ekonomik diplomasi yürütmek ve uluslararası iş birliklerini geliştirmek amacıyla İstanbul merkezli kurulmuş, uluslararası vizyonlu bir sivil toplum kuruluşudur.",

    // Activity areas — 7 alan (Tüzük Madde 3)
    act_economy: "Ekonomi ve Ticaret",
    act_economy_desc: "Uluslararası ticaret ve yatırım organizasyonları, iş geliştirme, yatırım danışmanlığı ve pazar araştırmaları ile Türk firmalarının uluslararası pazarlara erişimini destekliyoruz.",
    act_industry: "Sanayi, Teknoloji ve Savunma",
    act_industry_desc: "Teknoloji geliştirme, inovasyon, dijital dönüşüm, yapay zekâ, siber güvenlik ve savunma sanayii alanlarında uluslararası iş birliği projeleri yürütüyoruz.",
    act_education: "Eğitim ve Akademik Faaliyetler",
    act_education_desc: "Eğitim programları, seminerler, kongreler, çalıştaylar; üniversitelerle ortak araştırmalar, burs ve akademik değişim programları geliştiriyoruz.",
    act_social: "Sosyal Kalkınma",
    act_social_desc: "Sosyal ve insani yardım projeleri, kadın-genç-dezavantajlı grupların ekonomik hayata katılımı ve afet sonrası yeniden yapılanma çalışmaları yürütüyoruz.",
    act_culture: "Kültürel Diplomasi",
    act_culture_desc: "Kültürel etkinlikler, fuarlar, festivaller ve tanıtım organizasyonları ile Türkiye'nin kültürel mirasının uluslararası alanda tanıtımına katkı sağlıyoruz.",
    act_research: "Araştırma ve Yayın",
    act_research_desc: "Araştırma raporları, süreli ve süresiz yayınlar, dijital yayın platformları ile bilimsel bilgi üretimini ve paylaşımını destekliyoruz.",
    act_financial: "Mali ve Ticari Faaliyetler",
    act_financial_desc: "İktisadi işletme, şirket ortaklığı, taşınır-taşınmaz mal edinme, ulusal ve uluslararası fonlardan yararlanma ile amaçlarımızı gerçekleştiriyoruz.",

    // International Program
    syria_title: "Uluslararası Kalkınma ve Ekonomik İş Birliği Programı",
    syria_body: "USEKO; başta Türk Devletleri, Balkanlar, Orta Doğu, Afrika ve Avrupa olmak üzere farklı coğrafyalarda sürdürülebilir kalkınma, ekonomik iş birliği, kamu diplomasisi ve insani yardım projeleri yürütür. Yerel paydaşlar, üniversiteler, kalkınma ajansları, yatırım kuruluşları ve kamu kurumlarıyla ortak çalışmalar geliştirir.",

    // Business Network
    business_title: "İş İnsanları İçin Uluslararası İş Birliği Ağı",
    business_body: "USEKO, üyeleri arasında sektörel iş birlikleri, uluslararası proje ortaklıkları ve sürdürülebilir ekonomik bağlantılar geliştirmeyi hedefleyen güçlü bir iş dünyası ağı oluşturur.",
    business_cta_membership: "Kurumsal Üyelik",
    business_cta_form: "İş Birliği Formu",

    // President
    president_title: "Başkanın Mesajı",
    president_body: "USEKO olarak sürdürülebilir kalkınmayı, yardımlaşmayı ve ekonomik iş birliğini aynı çatı altında buluşturan güçlü bir yapı inşa ediyoruz. Amacımız; ihtiyaç duyulan coğrafyalarda eğitimden sağlığa, barınmadan altyapıya kadar kalıcı projeler geliştirmek ve toplumlar arasında güvene dayalı iş birlikleri kurmaktır.",

    // Transparency
    transparency_title: "Şeffaf, Ölçülebilir ve Sürdürülebilir Etki",
    transparency_body: "USEKO, yürüttüğü tüm faaliyetlerde şeffaflık, hesap verebilirlik, etik yönetim ve toplumsal fayda ilkelerini esas alır.",

    // News / Announcements
    latest_news: "Haberler",
    latest_announcements: "Duyurular",

    // Footer
    footer_desc: "Türkiye'nin ekonomik, teknolojik ve sosyal kalkınmasına katkı sağlıyor; uluslararası iş birliği ve ekonomik diplomasi ile güvenilir köprüler kuruyoruz.",
    quick_links: "Hızlı Bağlantılar",
    legal: "Yasal",
    contact_us: "İletişim",
    kvkk: "KVKK Aydınlatma Metni",
    privacy: "Gizlilik Politikası",
    cookies: "Çerez Politikası",
    terms: "Kullanım Şartları",
    all_rights: "Tüm hakları saklıdır.",

    // Cookie banner
    cookie_msg: "Web sitemizde deneyiminizi iyileştirmek için çerezler kullanılmaktadır. Detaylar için çerez politikamızı inceleyebilirsiniz.",
    cookie_accept: "Kabul Et",
    cookie_decline: "Sadece Zorunlu",

    // Status
    status_planned: "Planlanıyor",
    status_ongoing: "Devam Ediyor",
    status_completed: "Tamamlandı",
    status_preparing: "Hazırlık Aşamasında",

    // Forms
    form_name: "Ad Soyad",
    form_email: "E-posta",
    form_phone: "Telefon",
    form_company: "Firma / Kurum",
    form_title: "Unvan",
    form_city: "Şehir",
    form_country: "Ülke",
    form_sector: "Sektör",
    form_website: "Web Sitesi",
    form_message: "Mesaj",
    form_subject: "Konu",
    form_membership_type: "Üyelik Tipi",
    form_activity_area: "Faaliyet Alanı",
    form_desc: "Kısa Tanıtım / Açıklama",
    form_interested_fields: "İlgilendiğiniz Alanlar",
    form_intl_experience: "Uluslararası Deneyim",
    form_profession: "Meslek",
    form_age_range: "Yaş Aralığı",
    form_volunteer_fields: "Gönüllü Olmak İstediğiniz Alanlar",
    form_available_days: "Uygun Günler",
    form_experience: "Deneyim",
    form_partnership_type: "İş Birliği Türü",
    form_reference_projects: "Referans Projeler",
    form_kvkk: "KVKK Aydınlatma Metni'ni okudum ve kabul ediyorum.",
    form_contact_person: "Yetkili Kişi",
    form_interested_area: "İlgilenilen Alan",
    form_project_description: "Proje / Talep Açıklaması",
    form_consent: "Kişisel verilerimin başvurumun değerlendirilmesi amacıyla işlenmesini kabul ediyorum.",
    form_submitted: "Başvurunuz başarıyla alındı. En kısa sürede dönüş yapılacaktır.",
    form_error: "Başvuru gönderilirken bir hata oluştu.",
    form_required: "Bu alan zorunludur",

    // Membership
    membership_hero_title: "USEKO Üyeliği",
    membership_hero_desc: "USEKO üyeleri; sürdürülebilir kalkınma, sosyal fayda ve uluslararası ekonomik iş birliği alanlarında ortak değer üretmeyi hedefleyen güçlü bir topluluğun parçası olur.",

    // Volunteer
    volunteer_hero_title: "İyiliğin Bir Parçası Olun",
    volunteer_hero_desc: "USEKO gönüllüleri; eğitim, sağlık, afet desteği, sosyal kalkınma ve saha projelerinde toplumsal fayda üretmek için çalışan güçlü bir dayanışma ağının parçasıdır.",

    // Partnership
    partnership_hero_title: "Kurumsal İş Birliği ve Proje Ortaklığı",
    partnership_hero_desc: "USEKO; kurumlar, şirketler, sivil toplum kuruluşları, yerel paydaşlar ve kamu/özel sektör temsilcileriyle sürdürülebilir kalkınma, sosyal fayda ve ekonomik iş birliği alanlarında ortak projeler geliştirmeyi hedefler.",

    // Projects page
    projects_hero_title: "Projelerimiz",
    projects_hero_desc: "Sürdürülebilir kalkınma, sosyal fayda ve uluslararası iş birliği alanlarında geliştirdiğimiz projeler.",
    filter_all: "Tümü",
    filter_category: "Kategori",
    filter_status: "Durum",
    no_results: "Sonuç bulunamadı.",

    // Contact
    contact_hero_title: "Bize Ulaşın",
    contact_hero_desc: "Sorularınız, iş birliği önerileriniz ve başvurularınız için bizimle iletişime geçin.",

    // Admin
    admin_login_title: "Yönetim Paneli Girişi",
    admin_login_desc: "Devam etmek için giriş yapın",
    admin_password: "Şifre",
    admin_signin: "Giriş Yap",
    admin_signout: "Çıkış",
    admin_dashboard: "Kontrol Paneli",
    admin_stats: "Genel Bakış",

    // Common
    loading: "Yükleniyor...",
    read_more: "Devamını Oku",
    back: "Geri",
    save: "Kaydet",
    cancel: "İptal",
    edit: "Düzenle",
    delete: "Sil",
    add_new: "Yeni Ekle",
    search: "Ara...",
    view: "Görüntüle",
    status: "Durum",
    date: "Tarih",
    actions: "İşlemler",

    // Hero stats
    stat_activities: "Faaliyet Alanı",
    stat_languages: "Dil Desteği",
    stat_partnerships: "Ortaklık",
    hero_overline: "USEKO · Uluslararası STK",
    hero_badge_label: "Etki",
    hero_badge_text: "Sürdürülebilir kalkınma odaklı projeler",

    // Premium Hero (Midnight & Gold)
    premium_overline: "Küresel İş Birliğiyle",
    premium_title: "Birlikte Üretiyoruz,\nBirlikte Büyüyoruz,\nBirlikte Geleceğimizi\nŞekillendiriyoruz",
    premium_subtitle: "Ekonomik kalkınma, iş birliği ve insani dayanışma ile daha güçlü toplumlar ve yaşanabilir bir dünya için çalışıyoruz.",
    premium_cta_primary: "Hakkımızda",
    premium_cta_secondary: "Faaliyetlerimiz",

    // Value proposition strip (5 items)
    vp_global_title: "Küresel İş Birliği",
    vp_global_desc: "Uluslararası iş birlikleri ve ortaklık ağları kuruyoruz.",
    vp_econ_title: "Ekonomik Kalkınma",
    vp_econ_desc: "Sürdürülebilir ekonomik büyümeyi ve yatırımları destekliyoruz.",
    vp_trade_title: "Ticaret ve Yatırım",
    vp_trade_desc: "Ticaret hacmini artırmak için platformlar oluşturuyoruz.",
    vp_org_title: "Organizasyonel Güç",
    vp_org_desc: "Ulusal ve uluslararası etkinlik ve organizasyonlar düzenliyoruz.",
    vp_solidarity_title: "Yardımlaşma ve Dayanışma",
    vp_solidarity_desc: "İnsani yardım ve sosyal projelerle toplumsal dayanışmayı güçlendiriyoruz.",

    // Stats
    stat_member_orgs: "Üye Kuruluş",
    stat_countries: "Ülkede İş Birliği",
    stat_completed_projects: "Tamamlanan Proje",
    stat_yearly_events: "Yıllık Etkinlik",

    // Quote
    quote_body: "Birlikte üretiyor, birlikte büyüyor, birlikte geleceğimizi şekillendiriyoruz.",
    quote_signature: "USEKO ile geleceğe değer katıyoruz.",

    // Values (Tüzük Madde 4 — Temel İlkeler, 12 ilke)
    values: [
      { title: "Hukukun Üstünlüğü", desc: "Tüm faaliyetlerimizde hukuka ve mevzuata bağlılık." },
      { title: "Demokrasi ve Katılımcılık", desc: "Karar süreçlerinde çoğulcu ve katılımcı yaklaşım." },
      { title: "Şeffaflık ve Hesap Verebilirlik", desc: "Açık, izlenebilir ve raporlanabilir yönetim." },
      { title: "Tarafsızlık ve Eşitlik", desc: "Ayrım gözetmeksizin eşit ve adil yaklaşım." },
      { title: "İnsan Haklarına Saygı", desc: "Her bireyin haklarını ve onurunu koruruz." },
      { title: "Çevresel Sürdürülebilirlik", desc: "Doğal kaynakları ve gezegeni koruruz." },
      { title: "Etik Yönetim Anlayışı", desc: "Yüksek etik standartlarla yönetim." },
      { title: "Kurumsal Yönetişim İlkeleri", desc: "Uluslararası standartlarda yönetişim." },
      { title: "Bilimsel Yaklaşım", desc: "Kanıta ve bilime dayalı karar alma." },
      { title: "Gönüllülük", desc: "Toplumsal katılımın ve dayanışmanın gücü." },
      { title: "Toplumsal Fayda", desc: "Ölçülebilir ve kalıcı sosyal etki." },
      { title: "Uluslararası İş Birliği", desc: "Sınırları aşan ortaklık ve dayanışma." },
    ],

    // Page overlines / labels
    ov_corporate: "Kurumsal",
    ov_projects: "Projeler",
    ov_project: "Proje",
    ov_activity_area: "Faaliyet Alanı",
    ov_activity_areas: "Faaliyet Alanları",
    ov_news: "Haberler",
    ov_announcements: "Duyurular",
    ov_announcement: "Duyuru",
    ov_membership: "Üyelik",
    ov_volunteer: "Gönüllülük",
    ov_business_world: "İş Dünyası",
    ov_program: "Program",
    ov_mission: "Misyon",
    ov_vision: "Vizyon",

    // Common sub-titles used on multiple pages
    heading_focus_areas: "Odak Alanlarımız",
    heading_how_to_contribute: "Nasıl Katkı Sağlayabilirsiniz?",
    focus_areas_body: "USEKO bu alanda; yerel ve uluslararası paydaşlarla birlikte sürdürülebilir, ölçülebilir ve kalıcı etki üretmeyi hedefler. Faaliyetlerimiz şeffaflık, hesap verebilirlik ve etik yönetim ilkeleri çerçevesinde yürütülür.",
    contribute_body: "Bu alandaki projelerimize gönüllü olarak, kurumsal iş birliği ile veya üye olarak destek olabilirsiniz.",
    area_contact_heading: "İletişim",
    area_contact_body: "Bu faaliyet alanıyla ilgili sorularınız, iş birliği önerileriniz veya projeleriniz için bize aşağıdaki e-posta adresinden kolayca ulaşabilirsiniz.",
    view_projects: "Projeleri İncele",
    apply_partnership: "İş Birliği Başvurusu",
    back_to_projects: "Projelere Dön",
    not_found_title: "Sayfa bulunamadı",
    not_found_body: "Aradığınız sayfa mevcut değil veya taşınmış olabilir.",
    back_to_home: "Anasayfaya Dön",

    // Home page section headings
    home_activities_title: "USEKO Faaliyetleri",
    home_activities_desc: "Ekonomi ve ticaretten sanayi ve teknolojiye, kültürel diplomasiden araştırma ve yayına — kalıcı etki için çalışıyoruz.",
    home_projects_title: "Öne Çıkan Projeler",
    home_projects_desc: "Sürdürülebilir kalkınma ve sosyal fayda için geliştirdiğimiz projeler.",
    home_news_title: "Son Haberler",
    home_announcements_title: "Duyurular",
    cta_join_desc: "USEKO topluluğuna katılın",
    cta_volunteer_desc: "İyiliğin bir parçası olun",
    cta_partnership_desc: "Kurumsal iş birliği başlatın",

    // International program region tiles
    region_turk_states: "Türk Devletleri",
    region_balkans: "Balkanlar",
    region_middle_east: "Orta Doğu",
    region_africa: "Afrika",
    region_europe: "Avrupa",
    region_global: "Küresel Ağ",
    region_sub: "Kalkınma & iş birliği",

    // About page
    about_national_heading: "Ulusal Faaliyetlerimiz",
    about_national_body: "Girişimcilerin evrensel iş ahlakı ilkelerine uygun faaliyet göstermelerini teşvik eder; üniversiteler, kamu kurumları, özel sektör kuruluşları, meslek örgütleri ve sivil toplum kuruluşları arasında iş birliğini geliştiririz. Girişimcilik, yatırım, ihracat, dijital dönüşüm, yeşil ekonomi ve sürdürülebilir kalkınma alanlarında faaliyet yürütürüz.",
    about_international_heading: "Uluslararası Faaliyetlerimiz",
    about_international_body: "Türk iş dünyasının uluslararası pazarlardaki rekabet gücünü artırmaya yönelik çalışmalar yürütür; kamu diplomasisi, ekonomik diplomasi ve uluslararası iş birliği faaliyetleri gerçekleştiririz. Başta Türk Devletleri, Balkanlar, Orta Doğu, Afrika ve Avrupa olmak üzere farklı coğrafyalarda sürdürülebilir kalkınma projeleri yürütürüz.",
    about_hq_body: "Dernek merkezi İstanbul'dur. USEKO; katılımcı demokrasi, hukukun üstünlüğü, serbest girişim, rekabetçi piyasa ekonomisi ve sürdürülebilir kalkınma ilkelerinin gelişmesine katkı sağlar. Türkiye'nin ekonomik ve sosyal kalkınmasına ilişkin araştırmalar yapar, raporlar hazırlar ve kamu politikalarının geliştirilmesine katkıda bulunur.",
    about_focus_heading: "USEKO Faaliyetleri",

    // Mission page
    mission_hero_desc: "Türkiye'nin ekonomik, sosyal ve teknolojik kalkınmasına katkı sağlıyor, uluslararası iş birliğiyle geleceği inşa ediyoruz.",
    mission_title: "Kalıcı Fayda İçin",
    vision_title: "Uluslararası Ölçek",
    aim_overline: "Tüzük Madde 2 — Amaç ve Hedefler",
    aim_title: "Amacımız",
    aim_national: "Ulusal Düzeyde",
    aim_international: "Uluslararası Düzeyde",
    aim_national_items: [
      "Girişimcilerin evrensel iş ahlakı ilkelerine uygun faaliyetlerini teşvik etmek.",
      "Katılımcı demokrasi, hukukun üstünlüğü, serbest girişim ve sürdürülebilir kalkınma ilkelerinin gelişmesine katkı sağlamak.",
      "Türkiye'nin ekonomik ve sosyal kalkınmasına ilişkin araştırmalar yapmak, raporlar hazırlamak, kamu politikalarının geliştirilmesine katkı sunmak.",
      "Üniversiteler, kamu kurumları, özel sektör, meslek örgütleri ve STK'lar arasında iş birliğini geliştirmek.",
      "Girişimcilik, yatırım, ihracat, dijital dönüşüm, yeşil ekonomi ve sürdürülebilir kalkınma alanlarında faaliyet yürütmek.",
    ],
    aim_international_items: [
      "Türk iş dünyasının uluslararası pazarlardaki rekabet gücünü artırmaya yönelik çalışmalar yürütmek.",
      "Türkiye'nin ekonomik, ticari ve kültürel ilişkilerinin geliştirilmesine katkı sağlamak.",
      "Kamu diplomasisi, ekonomik diplomasi ve uluslararası iş birliği faaliyetleri gerçekleştirmek.",
      "Eğitim, sağlık, altyapı, teknoloji, çevre ve sosyal kalkınma projeleri geliştirmek.",
      "Başta Türk Devletleri, Balkanlar, Orta Doğu, Afrika ve Avrupa olmak üzere sürdürülebilir kalkınma projeleri yürütmek.",
    ],

    // Home — USEKO Purpose section
    home_aim_title: "USEKO'nun Amacı",
    home_aim_desc: "Dernek; Türkiye'nin ekonomik, ticari, teknolojik, bilimsel, kültürel ve sosyal kalkınmasına katkı sağlamak; Türk girişimcilerinin, yatırımcılarının, sanayicilerinin ve iş insanlarının ulusal ve uluslararası alanda rekabet gücünü artırmak; sürdürülebilir kalkınmayı desteklemek; ekonomik diplomasi faaliyetleri yürütmek; uluslararası iş birliklerini geliştirmek; eğitim, araştırma, teknoloji transferi, inovasyon, insani yardım ve sosyal sorumluluk projeleri gerçekleştirmek amacıyla kurulmuştur.",
    home_aim_national_title: "Ulusal Düzeyde",
    home_aim_national_items: [
      "a) Girişimcilerin evrensel iş ahlakı ilkelerine uygun faaliyet göstermelerini teşvik eder.",
      "b) Katılımcı demokrasi, hukukun üstünlüğü, serbest girişim, rekabetçi piyasa ekonomisi ve sürdürülebilir kalkınma ilkelerinin gelişmesine katkı sağlar.",
      "c) Türkiye'nin ekonomik ve sosyal kalkınmasına ilişkin araştırmalar yapar, raporlar hazırlar ve kamu politikalarının geliştirilmesine katkıda bulunur.",
      "ç) Üniversiteler, kamu kurumları, özel sektör kuruluşları, meslek örgütleri ve sivil toplum kuruluşları arasında iş birliğini geliştirir.",
      "d) Girişimcilik, yatırım, ihracat, dijital dönüşüm, yeşil ekonomi ve sürdürülebilir kalkınma alanlarında faaliyet yürütür.",
      "e) Ortaya çıkan görüş ve önerileri ilgili kamu kurumları, uluslararası kuruluşlar ve kamuoyu ile paylaşır.",
    ],
    home_aim_international_title: "Uluslararası Düzeyde",
    home_aim_international_items: [
      "a) Türk iş dünyasının uluslararası pazarlardaki rekabet gücünü artırmaya yönelik çalışmalar yürütür.",
      "b) Türkiye'nin ekonomik, ticari ve kültürel ilişkilerinin geliştirilmesine katkı sağlar.",
      "c) Kamu diplomasisi, ekonomik diplomasi ve uluslararası iş birliği faaliyetleri gerçekleştirir.",
      "ç) Eğitim, sağlık, altyapı, teknoloji, çevre ve sosyal kalkınma projeleri geliştirir ve uygular.",
      "d) Başta Türk Devletleri, Balkanlar, Orta Doğu, Afrika ve Avrupa olmak üzere farklı coğrafyalarda sürdürülebilir kalkınma projeleri yürütür.",
      "e) Kamu kurumları, uluslararası kuruluşlar, üniversiteler, kalkınma ajansları, yatırım kuruluşları ve özel sektör temsilcileri ile ortak çalışmalar yapabilir.",
    ],

    // Principles page
    principles_desc: "Faaliyetlerimizi şekillendiren temel değerlerimiz.",

    // Documents page
    documents_desc: "Dernek tüzüğü, faaliyet raporları ve resmi belgeler.",
    documents_empty: "Henüz belge yayınlanmamıştır. Yakında burada olacak.",

    // Board page
    board_desc: "USEKO Yönetim Kurulu üyeleri ve görevleri.",

    // News page
    news_hero_desc: "USEKO'dan güncel haberler, faaliyetler ve programlar.",
    announcements_hero_desc: "USEKO'nun güncel duyuruları ve bilgilendirme notları.",

    // Filters
    filter_all_status: "Tüm Durumlar",
    project_categories: {
      "": "Tümü",
      economy: "Ekonomi ve Ticaret",
      industry: "Sanayi & Teknoloji",
      education: "Eğitim & Akademik",
      social: "Sosyal Kalkınma",
      culture: "Kültürel Diplomasi",
      research: "Araştırma & Yayın",
    },
    project_status_labels: {
      "": "Tüm Durumlar",
      planned: "Planlanan",
      ongoing: "Devam Eden",
      completed: "Tamamlanan",
    },

    // Detail labels
    detail_category: "Kategori",
    detail_country: "Ülke",
    detail_city: "Şehir",
    detail_start: "Başlangıç",
    detail_end: "Bitiş",
    detail_status: "Durum",

    // Membership types
    mtype_individual: "Bireysel Üye",
    mtype_corporate: "Kurumsal Üye",
    mtype_volunteer: "Gönüllü Üye",
    mtype_supporter: "Destekçi Üye",

    // Partnership types
    ptype_project: "Proje Ortaklığı",
    ptype_sponsorship: "Sponsorluk",
    ptype_support: "Kurumsal Destek",
    ptype_trade: "Ticaret & Yatırım İş Birliği",
    ptype_research: "Araştırma & Akademik",
    ptype_b2b: "B2B / Ticari Görüşme",
    ptype_diplomatic: "Kamu / Ekonomik Diplomasi",

    // Volunteer fields
    vfield_education: "Eğitim",
    vfield_research: "Araştırma",
    vfield_trade: "Ticaret/Ekonomi",
    vfield_logistics: "Lojistik",
    vfield_social_media: "Sosyal Medya",
    vfield_translation: "Çeviri",
    vfield_field: "Saha Çalışması",
    vfield_organization: "Organizasyon",
    vfield_data: "Veri Girişi",

    // Interested area options (top-level)
    iarea_economy: "Ekonomi ve Ticaret",
    iarea_industry: "Sanayi, Teknoloji ve Savunma",
    iarea_education: "Eğitim ve Akademik",
    iarea_social: "Sosyal Kalkınma",
    iarea_culture: "Kültürel Diplomasi",
    iarea_research: "Araştırma ve Yayın",
    iarea_financial: "Mali ve Ticari Faaliyetler",
    iarea_volunteer: "Gönüllülük",

    // Days
    day_mon: "Pzt", day_tue: "Sal", day_wed: "Çar", day_thu: "Per",
    day_fri: "Cum", day_sat: "Cmt", day_sun: "Paz",

    // Contact
    contact_addr_line: "İstanbul, Türkiye",
    contact_addr_label: "Adres",
    contact_phone_label: "Telefon",
    contact_email_label: "E-posta",
    footer_credit_prefix: "Bu web sitesi",
    footer_credit_suffix: "tarafından geliştirilmiştir.",

    // Activity-area bullets (per slug)
    act_bullets: {
      "ekonomi-ticaret": [
        "Uluslararası ticaret ve yatırım organizasyonları",
        "İş geliştirme ve yatırım danışmanlığı",
        "Pazar araştırmaları ve sektörel analizler",
        "Türk firmalarının uluslararası pazarlara erişim desteği",
        "Fuar, heyet ve B2B iş görüşmeleri",
        "İhracat ve yatırım süreçlerinde bilgilendirme",
      ],
      "sanayi-teknoloji-savunma": [
        "Teknoloji geliştirme ve inovasyon projeleri",
        "Dijital dönüşüm ve yapay zekâ çalışmaları",
        "Siber güvenlik iş birlikleri",
        "Savunma sanayii alanında uluslararası ortaklıklar",
        "Ar-Ge ve teknoloji transferi",
        "Sanayi 4.0 ve akıllı üretim",
      ],
      "egitim-akademik": [
        "Eğitim programları, seminer, kongre ve çalıştaylar",
        "Üniversitelerle ortak araştırmalar",
        "Burs ve akademik değişim programları",
        "Mesleki eğitim projeleri",
        "Gençlik ve liderlik programları",
        "Uluslararası akademik iş birlikleri",
      ],
      "sosyal-kalkinma": [
        "Sosyal yardım ve insani yardım projeleri",
        "Kadınların ekonomik hayata katılımı",
        "Gençlik ve dezavantajlı grupların desteklenmesi",
        "Afet sonrası yeniden yapılanma katkıları",
        "Yerel kalkınma programları",
        "Toplumsal dayanışma girişimleri",
      ],
      "kulturel-diplomasi": [
        "Uluslararası kültürel etkinlikler",
        "Fuarlar, festivaller ve tanıtım organizasyonları",
        "Türkiye'nin kültürel mirasının uluslararası tanıtımı",
        "Kültürel değişim programları",
        "Sanat ve kültür iş birlikleri",
        "Kamu diplomasisi girişimleri",
      ],
      "arastirma-yayin": [
        "Araştırma raporları ve politika belgeleri",
        "Süreli ve süresiz yayınlar",
        "Dijital yayın platformları",
        "Akademik ve saha çalışmaları",
        "Sektörel analizler",
        "Kamuoyu paylaşımları",
      ],
      "mali-ticari": [
        "İktisadi işletme kurma",
        "Şirket kuruluşu ve ortaklıklar",
        "Taşınır ve taşınmaz mal edinme",
        "Bağış ve fon yönetimi",
        "Ulusal ve uluslararası fonlardan yararlanma",
        "Vakıf kurma ve iş birlikleri",
      ],
    },

    // Legal short bodies
    legal_kvkk_intro: "6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında USEKO tarafından toplanan kişisel verileriniz, başvurunuzun değerlendirilmesi ve iletişim amacıyla işlenmektedir.",
    legal_privacy_intro: "USEKO, kullanıcı gizliliğini korumayı taahhüt eder. Toplanan tüm veriler yalnızca belirtilen amaçlar doğrultusunda kullanılır.",
    legal_cookies_intro: "Web sitemiz temel işlevsellik, analitik ve pazarlama amaçlı çerezler kullanır. Çerez tercihlerinizi istediğiniz zaman değiştirebilirsiniz.",
    legal_terms_intro: "Bu sitenin kullanımı USEKO kullanım şartlarına tabidir. Siteyi kullanarak bu şartları kabul etmiş sayılırsınız.",
  },

  en: {
    lang_name: "English",
    lang_code: "en",
    dir: "ltr",
    org_short: "USEKO",
    org_full: "International Association for Sustainable Development, Economic Cooperation and Organization",
    slogan: "Building the Future Together",
    nav_home: "Home",
    nav_about: "About",
    nav_about_us: "About Us",
    nav_mission: "Mission & Vision",
    nav_principles: "Core Principles",
    nav_documents: "Charter & Documents",
    nav_president: "President's Message",
    nav_board: "Board of Directors",
    nav_activities: "Activity Areas",
    nav_projects: "Projects",
    nav_syria: "International Program",
    nav_membership: "Membership",
    nav_support: "Support",
    nav_volunteer: "Volunteer",
    nav_partnership: "Partnership",
    nav_news: "News",
    nav_announcements: "Announcements",
    nav_contact: "Contact",
    nav_admin: "Admin",
    nav_chairmanships: "Chairmanships",

    // Chairmanships
    chair_overline: "Governance",
    chair_home_title: "Our Chairmanships",
    chair_home_desc: "In line with our bylaws, sectoral and functional chairmanships have been established for effective execution of activities. Each chairmanship develops strategy and delivers projects under the coordination of the relevant activity area.",
    chair_type_sektorel: "Sectoral Chairmanship",
    chair_type_fonksiyonel: "Functional Chairmanship",
    chair_type_sektorel_plural: "Sectoral Chairmanships",
    chair_type_fonksiyonel_plural: "Functional Chairmanships",
    chair_intro_desc: "One of the chairmanships operating under the USEKO Board of Directors.",
    chair_scope_heading: "Scope of Duty",
    chair_scope_body: "This chairmanship operates within the scope of the {parent} activity area. Within the mandate defined by the Board, it develops strategy in the relevant sector/function, delivers projects and coordinates with stakeholders.",
    chair_activities_heading: "Our Activities",
    chair_bullet_1: "Strategy, roadmap and policy development",
    chair_bullet_2: "Collaboration with national and international stakeholders",
    chair_bullet_3: "Research, reports and recommendations",
    chair_bullet_4: "Project design and delivery",
    chair_bullet_5: "Capacity building and knowledge sharing",
    chair_parent_overline: "Reporting Activity Area",
    btn_join: "Join",
    btn_projects: "Explore Projects",
    btn_volunteer: "Volunteer",
    btn_partnership: "Partnership Application",
    btn_learn_more: "Learn More",
    btn_read_more: "Read More",
    btn_view_program: "View Program",
    btn_send: "Send",
    btn_submit: "Submit Application",
    btn_all: "View All",
    hero_title: "Building the Future Together",
    hero_sub: "USEKO contributes to Türkiye's economic, technological and social development and builds bridges for stronger societies through international cooperation and economic diplomacy.",
    home_mission_overline: "Our Mission",
    home_mission_title: "For Lasting Benefit",
    home_mission_body: "USEKO's mission is to contribute to Türkiye's economic, commercial, technological, scientific, cultural and social development; to strengthen the competitiveness of Turkish entrepreneurs, investors and businesses in national and international arenas; and to support sustainable development through economic diplomacy, education, research, technology transfer, innovation, humanitarian aid and social responsibility projects.",
    home_vision_overline: "Our Vision",
    home_vision_title: "International Scale",
    home_vision_body: "USEKO's vision is to become a reliable, respected international civil society platform that unites sustainable development, economic cooperation and public diplomacy across the Turkic States, the Balkans, the Middle East, Africa and Europe — built on the rule of law and a scientific approach.",
    what_is_useko: "What is USEKO?",
    what_is_useko_desc: "USEKO is an Istanbul-based, internationally oriented civil society organization founded to contribute to Türkiye's economic, commercial, technological, scientific, cultural and social development, to pursue economic diplomacy and to develop international cooperation.",
    act_economy: "Economy & Trade",
    act_economy_desc: "International trade and investment organizations, business development, investment consulting, market research; supporting Turkish firms' access to global markets.",
    act_industry: "Industry, Technology & Defense",
    act_industry_desc: "Technology development and innovation projects; digital transformation, AI, cybersecurity; international cooperation in the defense industry.",
    act_education: "Education & Academic Activities",
    act_education_desc: "Educational programs, seminars, congresses, workshops; joint research with universities; scholarship and academic exchange programs.",
    act_social: "Social Development",
    act_social_desc: "Social aid and humanitarian projects; economic participation of women, youth and disadvantaged groups; post-disaster reconstruction contributions.",
    act_culture: "Cultural Diplomacy",
    act_culture_desc: "Cultural events, fairs, festivals and promotion organizations; contributing to the international promotion of Türkiye's cultural heritage.",
    act_research: "Research & Publications",
    act_research_desc: "Research reports; periodicals and books; digital publishing platforms — supporting scientific knowledge production and dissemination.",
    act_financial: "Financial & Commercial Activities",
    act_financial_desc: "Establishing economic enterprises, partnering with companies, acquiring movable/immovable assets, benefiting from national and international funds.",
    syria_title: "International Development & Economic Cooperation Program",
    syria_body: "USEKO carries out sustainable development, economic cooperation, public diplomacy and humanitarian projects — primarily across the Turkic States, the Balkans, the Middle East, Africa and Europe — in partnership with local stakeholders, universities, development agencies and public institutions.",
    business_title: "International Cooperation Network for Business Leaders",
    business_body: "USEKO builds a strong business network to develop sectoral cooperation, international project partnerships and sustainable economic connections among its members.",
    business_cta_membership: "Corporate Membership",
    business_cta_form: "Partnership Form",
    president_title: "President's Message",
    president_body: "At USEKO, we build a strong structure that unites sustainable development, mutual assistance and economic cooperation under one roof. Our purpose is to develop lasting projects from education to health, housing to infrastructure — and to build trust-based cooperation between societies.",
    transparency_title: "Transparent, Measurable and Sustainable Impact",
    transparency_body: "USEKO puts transparency, accountability, ethical management and social benefit at the core of everything it does.",
    latest_news: "News",
    latest_announcements: "Announcements",
    footer_desc: "We build reliable bridges in sustainable development, international assistance and economic cooperation.",
    quick_links: "Quick Links",
    legal: "Legal",
    contact_us: "Contact",
    kvkk: "Data Protection Notice",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    terms: "Terms of Use",
    all_rights: "All rights reserved.",
    cookie_msg: "We use cookies to improve your experience on our website. See our cookie policy for details.",
    cookie_accept: "Accept",
    cookie_decline: "Essential only",
    status_planned: "Planned",
    status_ongoing: "Ongoing",
    status_completed: "Completed",
    status_preparing: "Preparing",
    form_name: "Full Name",
    form_email: "Email",
    form_phone: "Phone",
    form_company: "Company / Organization",
    form_title: "Title",
    form_city: "City",
    form_country: "Country",
    form_sector: "Sector",
    form_website: "Website",
    form_message: "Message",
    form_subject: "Subject",
    form_membership_type: "Membership Type",
    form_activity_area: "Activity Area",
    form_desc: "Short Description",
    form_interested_fields: "Areas of Interest",
    form_intl_experience: "International Experience",
    form_profession: "Profession",
    form_age_range: "Age Range",
    form_volunteer_fields: "Volunteer Fields",
    form_available_days: "Available Days",
    form_experience: "Experience",
    form_partnership_type: "Partnership Type",
    form_reference_projects: "Reference Projects",
    form_kvkk: "I have read and accept the Data Protection Notice.",
    form_contact_person: "Contact Person",
    form_interested_area: "Area of Interest",
    form_project_description: "Project / Request Description",
    form_consent: "I consent to my personal data being processed for the evaluation of my application.",
    form_submitted: "Your application has been received. We will get back to you soon.",
    form_error: "An error occurred while submitting your application.",
    form_required: "This field is required",
    membership_hero_title: "USEKO Membership",
    membership_hero_desc: "USEKO members join a strong community aiming to create shared value in sustainable development, social benefit and international economic cooperation.",
    volunteer_hero_title: "Be a Part of Good",
    volunteer_hero_desc: "USEKO volunteers work in education, health, disaster support, social development and field projects — part of a strong solidarity network.",
    partnership_hero_title: "Corporate Partnership & Project Cooperation",
    partnership_hero_desc: "USEKO develops joint projects with institutions, companies, civil society, local stakeholders and public/private sector representatives.",
    projects_hero_title: "Our Projects",
    projects_hero_desc: "Projects we develop in sustainable development, social benefit and international cooperation.",
    filter_all: "All",
    filter_category: "Category",
    filter_status: "Status",
    no_results: "No results.",
    contact_hero_title: "Get in Touch",
    contact_hero_desc: "Contact us for questions, partnership proposals and applications.",
    admin_login_title: "Admin Panel Login",
    admin_login_desc: "Sign in to continue",
    admin_password: "Password",
    admin_signin: "Sign In",
    admin_signout: "Sign Out",
    admin_dashboard: "Dashboard",
    admin_stats: "Overview",
    loading: "Loading...",
    read_more: "Read More",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    add_new: "Add New",
    search: "Search...",
    view: "View",
    status: "Status",
    date: "Date",
    actions: "Actions",
    stat_activities: "Activity Areas",
    stat_languages: "Languages",
    stat_partnerships: "Partnerships",
    hero_overline: "USEKO · International NGO",
    hero_badge_label: "Impact",
    hero_badge_text: "Sustainable development focused projects",

    premium_overline: "With Global Cooperation",
    premium_title: "Together We Produce,\nTogether We Grow,\nTogether We Shape\nOur Future",
    premium_subtitle: "We work for stronger societies and a livable world through economic development, cooperation and human solidarity.",
    premium_cta_primary: "About Us",
    premium_cta_secondary: "Our Activities",

    vp_global_title: "Global Cooperation",
    vp_global_desc: "We build international partnerships and cooperation networks.",
    vp_econ_title: "Economic Development",
    vp_econ_desc: "We support sustainable economic growth and investments.",
    vp_trade_title: "Trade & Investment",
    vp_trade_desc: "We create platforms to increase trade volume.",
    vp_org_title: "Organizational Power",
    vp_org_desc: "We organize national and international events and organizations.",
    vp_solidarity_title: "Solidarity & Assistance",
    vp_solidarity_desc: "We strengthen social solidarity through humanitarian aid and social projects.",

    stat_member_orgs: "Member Organizations",
    stat_countries: "Countries of Cooperation",
    stat_completed_projects: "Completed Projects",
    stat_yearly_events: "Yearly Events",

    quote_body: "Together we produce, together we grow, together we shape our future.",
    quote_signature: "We add value to the future with USEKO.",
    values: [
      { title: "Rule of Law", desc: "Full compliance with law and regulations." },
      { title: "Democracy & Participation", desc: "Pluralistic, participatory decision-making." },
      { title: "Transparency & Accountability", desc: "Open, traceable and reportable governance." },
      { title: "Impartiality & Equality", desc: "Non-discriminatory, fair approach." },
      { title: "Respect for Human Rights", desc: "We protect every individual's rights and dignity." },
      { title: "Environmental Sustainability", desc: "We protect natural resources and the planet." },
      { title: "Ethical Management", desc: "Governance by high ethical standards." },
      { title: "Corporate Governance", desc: "Governance to international standards." },
      { title: "Scientific Approach", desc: "Evidence and science-based decision-making." },
      { title: "Volunteering", desc: "The power of civic participation and solidarity." },
      { title: "Social Benefit", desc: "Measurable and lasting social impact." },
      { title: "International Cooperation", desc: "Cross-border partnerships and solidarity." },
    ],

    // Page overlines / labels
    ov_corporate: "Corporate",
    ov_projects: "Projects",
    ov_project: "Project",
    ov_activity_area: "Activity Area",
    ov_activity_areas: "Activity Areas",
    ov_news: "News",
    ov_announcements: "Announcements",
    ov_announcement: "Announcement",
    ov_membership: "Membership",
    ov_volunteer: "Volunteer",
    ov_business_world: "Business World",
    ov_program: "Program",
    ov_mission: "Mission",
    ov_vision: "Vision",

    heading_focus_areas: "Our Focus Areas",
    heading_how_to_contribute: "How Can You Contribute?",
    focus_areas_body: "In this area, USEKO aims to generate sustainable, measurable and lasting impact together with local and international stakeholders. All our activities are carried out under principles of transparency, accountability and ethical management.",
    contribute_body: "You can support our projects in this area as a volunteer, through corporate partnership, or by becoming a member.",
    area_contact_heading: "Contact",
    area_contact_body: "For questions about this activity area, collaboration proposals, or project ideas, you can easily reach us at the email address below.",
    view_projects: "View Projects",
    apply_partnership: "Partnership Application",
    back_to_projects: "Back to Projects",
    not_found_title: "Page not found",
    not_found_body: "The page you are looking for does not exist or may have been moved.",
    back_to_home: "Back to Home",

    home_activities_title: "USEKO Activities",
    home_activities_desc: "From economy and trade to industry and technology, from cultural diplomacy to research and publications — we work for lasting impact.",
    home_projects_title: "Featured Projects",
    home_projects_desc: "Projects we develop for sustainable development and social benefit.",
    home_news_title: "Latest News",
    home_announcements_title: "Announcements",
    cta_join_desc: "Join the USEKO community",
    cta_volunteer_desc: "Be part of the good",
    cta_partnership_desc: "Start a corporate partnership",

    region_turk_states: "Turkic States",
    region_balkans: "Balkans",
    region_middle_east: "Middle East",
    region_africa: "Africa",
    region_europe: "Europe",
    region_global: "Global Network",
    region_sub: "Development & cooperation",

    about_national_heading: "Our National Activities",
    about_national_body: "We encourage entrepreneurs to operate in accordance with universal business ethics; and develop cooperation among universities, public institutions, private sector, professional associations and NGOs. We work in entrepreneurship, investment, exports, digital transformation, the green economy and sustainable development.",
    about_international_heading: "Our International Activities",
    about_international_body: "We carry out studies to strengthen the international competitiveness of the Turkish business world; conduct public diplomacy, economic diplomacy and international cooperation activities. We deliver sustainable development projects across the Turkic States, the Balkans, the Middle East, Africa and Europe.",
    about_hq_body: "The association is headquartered in Istanbul. USEKO contributes to the development of participatory democracy, the rule of law, free enterprise, competitive market economy and sustainable development. It conducts research on Türkiye's economic and social development, prepares reports and contributes to the development of public policy.",
    about_focus_heading: "USEKO Activities",

    mission_hero_desc: "We contribute to Türkiye's economic, social and technological development and build the future through international cooperation.",
    mission_title: "For Lasting Benefit",
    vision_title: "International Scale",
    aim_overline: "Bylaws Article 2 — Aims and Objectives",
    aim_title: "Our Purpose",
    aim_national: "Nationally",
    aim_international: "Internationally",
    aim_national_items: [
      "Encourage entrepreneurs to act in accordance with universal business ethics.",
      "Contribute to the development of participatory democracy, the rule of law, free enterprise and sustainable development.",
      "Conduct research on Türkiye's economic and social development, prepare reports and contribute to public policy.",
      "Develop cooperation among universities, public institutions, the private sector, professional associations and NGOs.",
      "Operate in the fields of entrepreneurship, investment, exports, digital transformation, green economy and sustainable development.",
    ],
    aim_international_items: [
      "Strengthen the international competitiveness of the Turkish business world.",
      "Contribute to the development of Türkiye's economic, commercial and cultural relations.",
      "Conduct public diplomacy, economic diplomacy and international cooperation activities.",
      "Develop education, health, infrastructure, technology, environment and social development projects.",
      "Deliver sustainable development projects primarily across the Turkic States, the Balkans, the Middle East, Africa and Europe.",
    ],

    // Home — USEKO Purpose section
    home_aim_title: "The Purpose of USEKO",
    home_aim_desc: "USEKO was founded to contribute to Türkiye's economic, commercial, technological, scientific, cultural and social development; to strengthen the national and international competitiveness of Turkish entrepreneurs, investors, industrialists and business people; to support sustainable development; to conduct economic diplomacy activities; to expand international cooperation; and to deliver education, research, technology transfer, innovation, humanitarian aid and social responsibility projects.",
    home_aim_national_title: "At the National Level",
    home_aim_national_items: [
      "a) Encourages entrepreneurs to operate in line with universal business ethics.",
      "b) Contributes to the development of participatory democracy, the rule of law, free enterprise, a competitive market economy and sustainable development.",
      "c) Conducts research on Türkiye's economic and social development, prepares reports and contributes to the design of public policies.",
      "ç) Fosters cooperation among universities, public institutions, private sector organizations, professional bodies and civil society organizations.",
      "d) Operates in the fields of entrepreneurship, investment, exports, digital transformation, green economy and sustainable development.",
      "e) Shares its opinions and recommendations with relevant public institutions, international organizations and the public.",
    ],
    home_aim_international_title: "At the International Level",
    home_aim_international_items: [
      "a) Carries out activities to strengthen the international competitiveness of the Turkish business world.",
      "b) Contributes to the development of Türkiye's economic, commercial and cultural relations.",
      "c) Conducts public diplomacy, economic diplomacy and international cooperation activities.",
      "ç) Develops and implements education, health, infrastructure, technology, environment and social development projects.",
      "d) Runs sustainable development projects across various geographies, primarily the Turkic States, the Balkans, the Middle East, Africa and Europe.",
      "e) May work jointly with public institutions, international organizations, universities, development agencies, investment institutions and private sector representatives.",
    ],

    principles_desc: "Our core values that shape our activities.",
    documents_desc: "Association bylaws, activity reports and official documents.",
    documents_empty: "No documents have been published yet. Coming soon.",
    board_desc: "Members and roles of the USEKO Board of Directors.",
    news_hero_desc: "Latest news, activities and programs from USEKO.",
    announcements_hero_desc: "Current announcements and updates from USEKO.",

    filter_all_status: "All Statuses",
    project_categories: {
      "": "All",
      economy: "Economy & Trade",
      industry: "Industry & Technology",
      education: "Education & Academic",
      social: "Social Development",
      culture: "Cultural Diplomacy",
      research: "Research & Publications",
    },
    project_status_labels: {
      "": "All Statuses",
      planned: "Planned",
      ongoing: "Ongoing",
      completed: "Completed",
    },

    detail_category: "Category",
    detail_country: "Country",
    detail_city: "City",
    detail_start: "Start",
    detail_end: "End",
    detail_status: "Status",

    mtype_individual: "Individual Member",
    mtype_corporate: "Corporate Member",
    mtype_volunteer: "Volunteer Member",
    mtype_supporter: "Supporter Member",

    ptype_project: "Project Partnership",
    ptype_sponsorship: "Sponsorship",
    ptype_support: "Corporate Support",
    ptype_trade: "Trade & Investment Cooperation",
    ptype_research: "Research & Academic",
    ptype_b2b: "B2B / Business Meeting",
    ptype_diplomatic: "Public / Economic Diplomacy",

    vfield_education: "Education",
    vfield_research: "Research",
    vfield_trade: "Trade/Economy",
    vfield_logistics: "Logistics",
    vfield_social_media: "Social Media",
    vfield_translation: "Translation",
    vfield_field: "Field Work",
    vfield_organization: "Organization",
    vfield_data: "Data Entry",

    iarea_economy: "Economy & Trade",
    iarea_industry: "Industry, Technology & Defense",
    iarea_education: "Education & Academic",
    iarea_social: "Social Development",
    iarea_culture: "Cultural Diplomacy",
    iarea_research: "Research & Publications",
    iarea_financial: "Financial & Commercial",
    iarea_volunteer: "Volunteering",

    day_mon: "Mon", day_tue: "Tue", day_wed: "Wed", day_thu: "Thu",
    day_fri: "Fri", day_sat: "Sat", day_sun: "Sun",

    contact_addr_line: "Istanbul, Türkiye",
    contact_addr_label: "Address",
    contact_phone_label: "Phone",
    contact_email_label: "Email",
    footer_credit_prefix: "This website was developed by",
    footer_credit_suffix: ".",

    act_bullets: {
      "ekonomi-ticaret": [
        "International trade and investment organizations",
        "Business development and investment consulting",
        "Market research and sectoral analysis",
        "Access support for Turkish firms in international markets",
        "Fairs, delegations and B2B meetings",
        "Guidance in export and investment processes",
      ],
      "sanayi-teknoloji-savunma": [
        "Technology development and innovation projects",
        "Digital transformation and AI initiatives",
        "Cybersecurity partnerships",
        "International cooperation in defense industry",
        "R&D and technology transfer",
        "Industry 4.0 and smart manufacturing",
      ],
      "egitim-akademik": [
        "Training programs, seminars, congresses and workshops",
        "Joint research with universities",
        "Scholarship and academic exchange programs",
        "Vocational training projects",
        "Youth and leadership programs",
        "International academic cooperation",
      ],
      "sosyal-kalkinma": [
        "Social and humanitarian aid projects",
        "Women's participation in economic life",
        "Support for youth and disadvantaged groups",
        "Post-disaster reconstruction contributions",
        "Local development programs",
        "Community solidarity initiatives",
      ],
      "kulturel-diplomasi": [
        "International cultural events",
        "Fairs, festivals and promotion organizations",
        "International promotion of Türkiye's cultural heritage",
        "Cultural exchange programs",
        "Arts and culture partnerships",
        "Public diplomacy initiatives",
      ],
      "arastirma-yayin": [
        "Research reports and policy papers",
        "Periodicals and books",
        "Digital publishing platforms",
        "Academic and field studies",
        "Sectoral analyses",
        "Public knowledge sharing",
      ],
      "mali-ticari": [
        "Establishing economic enterprises",
        "Company incorporation and partnerships",
        "Acquisition of movable and immovable assets",
        "Grant and fund management",
        "Access to national and international funds",
        "Foundation establishment and cooperation",
      ],
    },

    legal_kvkk_intro: "Under Law No. 6698 on the Protection of Personal Data (KVKK), personal data collected by USEKO is processed for the evaluation of your application and communication purposes.",
    legal_privacy_intro: "USEKO is committed to protecting user privacy. All collected data is used only for stated purposes.",
    legal_cookies_intro: "Our website uses cookies for essential functionality, analytics and marketing. You can change your cookie preferences at any time.",
    legal_terms_intro: "Use of this site is subject to USEKO's terms of use. By using the site, you accept these terms.",
  },

  ar: {
    lang_name: "العربية",
    lang_code: "ar",
    dir: "rtl",
    org_short: "USEKO",
    org_full: "الجمعية الدولية للتنمية المستدامة والتعاون الاقتصادي والتنظيم",
    slogan: "نبني المستقبل معاً",
    nav_home: "الرئيسية",
    nav_about: "عن الجمعية",
    nav_about_us: "من نحن",
    nav_mission: "الرسالة والرؤية",
    nav_principles: "مبادئنا",
    nav_documents: "الوثائق",
    nav_president: "رسالة الرئيس",
    nav_board: "مجلس الإدارة",
    nav_activities: "مجالات النشاط",
    nav_projects: "المشاريع",
    nav_syria: "برنامج دولي",
    nav_membership: "العضوية",
    nav_support: "الدعم",
    nav_volunteer: "التطوع",
    nav_partnership: "الشراكة",
    nav_news: "الأخبار",
    nav_announcements: "الإعلانات",
    nav_contact: "اتصل بنا",
    nav_admin: "الإدارة",
    nav_chairmanships: "الرئاسات",

    chair_overline: "الحوكمة",
    chair_home_title: "رئاساتنا",
    chair_home_desc: "وفقًا للنظام الأساسي، تم إنشاء رئاسات قطاعية ووظيفية لتنفيذ الأنشطة بفعالية. تعمل كل رئاسة على تطوير الاستراتيجية وإدارة المشاريع تحت تنسيق مجال النشاط ذي الصلة.",
    chair_type_sektorel: "رئاسة قطاعية",
    chair_type_fonksiyonel: "رئاسة وظيفية",
    chair_type_sektorel_plural: "الرئاسات القطاعية",
    chair_type_fonksiyonel_plural: "الرئاسات الوظيفية",
    chair_intro_desc: "إحدى الرئاسات العاملة تحت مجلس إدارة يوسيكو.",
    chair_scope_heading: "نطاق العمل",
    chair_scope_body: "تعمل هذه الرئاسة ضمن مجال نشاط {parent}. وفق التوصيف الذي يحدده مجلس الإدارة، تطور الاستراتيجية في القطاع/الوظيفة ذات الصلة، وتنفذ المشاريع، وتنسق مع أصحاب المصلحة.",
    chair_activities_heading: "أنشطتنا",
    chair_bullet_1: "تطوير الاستراتيجية وخارطة الطريق والسياسات",
    chair_bullet_2: "التعاون مع أصحاب المصلحة الوطنيين والدوليين",
    chair_bullet_3: "إعداد الأبحاث والتقارير والتوصيات",
    chair_bullet_4: "تصميم المشاريع وتنفيذها",
    chair_bullet_5: "بناء القدرات وتبادل المعرفة",
    chair_parent_overline: "مجال النشاط المرتبط",
    btn_join: "انضم",
    btn_projects: "استكشف المشاريع",
    btn_volunteer: "تطوع",
    btn_partnership: "طلب شراكة",
    btn_learn_more: "اعرف المزيد",
    btn_read_more: "اقرأ المزيد",
    btn_view_program: "عرض البرنامج",
    btn_send: "إرسال",
    btn_submit: "إرسال الطلب",
    btn_all: "عرض الكل",
    hero_title: "نبني المستقبل معاً",
    hero_sub: "تُسهم USEKO في التنمية الاقتصادية والتكنولوجية والاجتماعية لتركيا وتبني جسوراً لمجتمعات أقوى من خلال التعاون الدولي والدبلوماسية الاقتصادية.",
    home_mission_overline: "رسالتنا",
    home_mission_title: "من أجل فائدة دائمة",
    home_mission_body: "رسالة USEKO هي الإسهام في التنمية الاقتصادية والتجارية والتكنولوجية والعلمية والثقافية والاجتماعية لتركيا؛ وتعزيز القدرة التنافسية لرواد الأعمال والمستثمرين ورجال الأعمال الأتراك على المستويين الوطني والدولي؛ ودعم التنمية المستدامة عبر الدبلوماسية الاقتصادية والتعليم والبحث ونقل التكنولوجيا والابتكار والمساعدات الإنسانية ومشاريع المسؤولية الاجتماعية.",
    home_vision_overline: "رؤيتنا",
    home_vision_title: "على نطاق دولي",
    home_vision_body: "رؤية USEKO أن تكون منصة مجتمع مدني موثوقة ومحترمة دولياً توحد التنمية المستدامة والتعاون الاقتصادي والدبلوماسية العامة في الدول التركية والبلقان والشرق الأوسط وأفريقيا وأوروبا، على أساس سيادة القانون والنهج العلمي.",
    what_is_useko: "ما هي USEKO؟",
    what_is_useko_desc: "USEKO منظمة مجتمع مدني ذات توجه دولي مقرها اسطنبول، تأسست للإسهام في التنمية الاقتصادية والتجارية والتكنولوجية والعلمية والثقافية والاجتماعية لتركيا وممارسة الدبلوماسية الاقتصادية وتطوير التعاون الدولي.",
    act_economy: "الاقتصاد والتجارة",
    act_economy_desc: "منظمات التجارة والاستثمار الدولية، تطوير الأعمال، استشارات الاستثمار، أبحاث السوق، ودعم وصول الشركات التركية إلى الأسواق العالمية.",
    act_industry: "الصناعة والتكنولوجيا والدفاع",
    act_industry_desc: "تطوير التكنولوجيا والابتكار، التحول الرقمي، الذكاء الاصطناعي، الأمن السيبراني، والتعاون الدولي في الصناعات الدفاعية.",
    act_education: "التعليم والأنشطة الأكاديمية",
    act_education_desc: "برامج تعليمية وندوات ومؤتمرات وورش عمل؛ أبحاث مشتركة مع الجامعات؛ برامج المنح والتبادل الأكاديمي.",
    act_social: "التنمية الاجتماعية",
    act_social_desc: "مشاريع المساعدات الاجتماعية والإنسانية؛ دعم مشاركة النساء والشباب والفئات المحرومة اقتصادياً؛ إعادة الإعمار بعد الكوارث.",
    act_culture: "الدبلوماسية الثقافية",
    act_culture_desc: "الفعاليات الثقافية والمعارض والمهرجانات ومنظمات الترويج؛ الإسهام في الترويج الدولي للتراث الثقافي التركي.",
    act_research: "البحث والنشر",
    act_research_desc: "تقارير بحثية ومنشورات دورية وغير دورية ومنصات نشر رقمية لدعم إنتاج المعرفة العلمية ونشرها.",
    act_financial: "الأنشطة المالية والتجارية",
    act_financial_desc: "تأسيس مؤسسات اقتصادية والشراكة مع الشركات والحصول على الأصول والاستفادة من الصناديق الوطنية والدولية.",
    syria_title: "برنامج التنمية والتعاون الاقتصادي الدولي",
    syria_body: "تنفذ USEKO مشاريع التنمية المستدامة والتعاون الاقتصادي والدبلوماسية العامة والمساعدات الإنسانية، خاصة في الدول التركية والبلقان والشرق الأوسط وأفريقيا وأوروبا، بالشراكة مع أصحاب المصلحة المحليين والجامعات والوكالات التنموية والمؤسسات الحكومية.",
    business_title: "شبكة التعاون الدولي لرجال الأعمال",
    business_body: "تبني USEKO شبكة أعمال قوية لتطوير التعاون القطاعي والشراكات الدولية.",
    business_cta_membership: "عضوية مؤسسية",
    business_cta_form: "نموذج الشراكة",
    president_title: "رسالة الرئيس",
    president_body: "في USEKO، نبني هيكلاً قوياً يوحد التنمية المستدامة والتنظيم والتعاون الاقتصادي تحت سقف واحد.",
    transparency_title: "أثر شفاف وقابل للقياس ومستدام",
    transparency_body: "تضع USEKO الشفافية والمساءلة والإدارة الأخلاقية والفائدة الاجتماعية في صميم كل ما تقوم به.",
    latest_news: "الأخبار",
    latest_announcements: "الإعلانات",
    footer_desc: "نبني جسوراً موثوقة في التنمية المستدامة والمساعدة الدولية والتعاون الاقتصادي.",
    quick_links: "روابط سريعة",
    legal: "قانوني",
    contact_us: "اتصل بنا",
    kvkk: "إشعار حماية البيانات",
    privacy: "سياسة الخصوصية",
    cookies: "سياسة الكوكيز",
    terms: "شروط الاستخدام",
    all_rights: "جميع الحقوق محفوظة.",
    cookie_msg: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك. راجع سياسة الكوكيز للتفاصيل.",
    cookie_accept: "قبول",
    cookie_decline: "الضرورية فقط",
    status_planned: "مخطط",
    status_ongoing: "جاري",
    status_completed: "مكتمل",
    status_preparing: "قيد الإعداد",
    form_name: "الاسم الكامل",
    form_email: "البريد الإلكتروني",
    form_phone: "الهاتف",
    form_company: "الشركة / المؤسسة",
    form_title: "المسمى",
    form_city: "المدينة",
    form_country: "الدولة",
    form_sector: "القطاع",
    form_website: "الموقع",
    form_message: "الرسالة",
    form_subject: "الموضوع",
    form_membership_type: "نوع العضوية",
    form_activity_area: "مجال النشاط",
    form_desc: "وصف قصير",
    form_interested_fields: "مجالات الاهتمام",
    form_intl_experience: "الخبرة الدولية",
    form_profession: "المهنة",
    form_age_range: "الفئة العمرية",
    form_volunteer_fields: "مجالات التطوع",
    form_available_days: "الأيام المتاحة",
    form_experience: "الخبرة",
    form_partnership_type: "نوع الشراكة",
    form_reference_projects: "مشاريع مرجعية",
    form_kvkk: "قرأت وأوافق على إشعار حماية البيانات.",
    form_contact_person: "الشخص المسؤول",
    form_interested_area: "مجال الاهتمام",
    form_project_description: "وصف المشروع / الطلب",
    form_consent: "أوافق على معالجة بياناتي الشخصية.",
    form_submitted: "تم استلام طلبك. سنعود إليك قريباً.",
    form_error: "حدث خطأ أثناء إرسال الطلب.",
    form_required: "هذا الحقل مطلوب",
    membership_hero_title: "عضوية USEKO",
    membership_hero_desc: "ينضم أعضاء USEKO إلى مجتمع قوي يهدف إلى إنتاج قيمة مشتركة.",
    volunteer_hero_title: "كن جزءاً من الخير",
    volunteer_hero_desc: "متطوعو USEKO يعملون في التعليم والصحة ودعم الكوارث.",
    partnership_hero_title: "الشراكة المؤسسية وتعاون المشاريع",
    partnership_hero_desc: "تطور USEKO مشاريع مشتركة مع المؤسسات والشركات.",
    projects_hero_title: "مشاريعنا",
    projects_hero_desc: "المشاريع التي نطورها في التنمية المستدامة والتعاون الدولي.",
    filter_all: "الكل",
    filter_category: "الفئة",
    filter_status: "الحالة",
    no_results: "لا توجد نتائج.",
    contact_hero_title: "تواصل معنا",
    contact_hero_desc: "اتصل بنا للأسئلة ومقترحات الشراكة والطلبات.",
    admin_login_title: "تسجيل دخول الإدارة",
    admin_login_desc: "سجّل الدخول للمتابعة",
    admin_password: "كلمة المرور",
    admin_signin: "تسجيل الدخول",
    admin_signout: "تسجيل الخروج",
    admin_dashboard: "لوحة التحكم",
    admin_stats: "نظرة عامة",
    loading: "جارٍ التحميل...",
    read_more: "اقرأ المزيد",
    back: "العودة",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    add_new: "إضافة جديد",
    search: "بحث...",
    view: "عرض",
    status: "الحالة",
    date: "التاريخ",
    actions: "إجراءات",
    stat_activities: "مجالات النشاط",
    stat_languages: "اللغات",
    stat_partnerships: "شراكات",
    hero_overline: "USEKO · منظمة دولية",
    hero_badge_label: "الأثر",
    hero_badge_text: "مشاريع تركز على التنمية المستدامة",

    premium_overline: "بالتعاون العالمي",
    premium_title: "نبني مستقبلاً مستداماً",
    premium_subtitle: "نعمل من أجل مجتمعات أقوى وعالم صالح للعيش من خلال التنمية الاقتصادية والتعاون والتضامن الإنساني.",
    premium_cta_primary: "من نحن",
    premium_cta_secondary: "أنشطتنا",

    vp_global_title: "التعاون العالمي",
    vp_global_desc: "نبني شراكات دولية وشبكات تعاون.",
    vp_econ_title: "التنمية الاقتصادية",
    vp_econ_desc: "ندعم النمو الاقتصادي المستدام والاستثمارات.",
    vp_trade_title: "التجارة والاستثمار",
    vp_trade_desc: "نبني منصات لزيادة حجم التجارة.",
    vp_org_title: "القوة التنظيمية",
    vp_org_desc: "ننظم فعاليات وتنظيمات وطنية ودولية.",
    vp_solidarity_title: "التضامن والمساعدة",
    vp_solidarity_desc: "نعزز التضامن الاجتماعي من خلال المساعدة الإنسانية والمشاريع الاجتماعية.",

    stat_member_orgs: "منظمة عضو",
    stat_countries: "دولة للتعاون",
    stat_completed_projects: "مشروع مكتمل",
    stat_yearly_events: "فعالية سنوية",

    quote_body: "معاً ننتج، معاً ننمو، معاً نشكّل مستقبلنا.",
    quote_signature: "نضيف قيمة إلى المستقبل مع USEKO.",
    values: [
      { title: "سيادة القانون", desc: "الالتزام الكامل بالقانون واللوائح." },
      { title: "الديمقراطية والمشاركة", desc: "صنع قرار تعددي وتشاركي." },
      { title: "الشفافية والمساءلة", desc: "حوكمة مفتوحة وقابلة للتتبع." },
      { title: "الحياد والمساواة", desc: "نهج عادل وغير تمييزي." },
      { title: "احترام حقوق الإنسان", desc: "نحمي حقوق وكرامة كل فرد." },
      { title: "الاستدامة البيئية", desc: "نحمي الموارد الطبيعية والكوكب." },
      { title: "الإدارة الأخلاقية", desc: "حوكمة بمعايير أخلاقية عالية." },
      { title: "الحوكمة المؤسسية", desc: "حوكمة وفق المعايير الدولية." },
      { title: "النهج العلمي", desc: "قرارات مبنية على الأدلة والعلم." },
      { title: "التطوع", desc: "قوة المشاركة المدنية والتضامن." },
      { title: "الفائدة الاجتماعية", desc: "أثر اجتماعي قابل للقياس ودائم." },
      { title: "التعاون الدولي", desc: "شراكات وتضامن عابر للحدود." },
    ],

    // Page overlines / labels
    ov_corporate: "مؤسسي",
    ov_projects: "المشاريع",
    ov_project: "مشروع",
    ov_activity_area: "مجال النشاط",
    ov_activity_areas: "مجالات النشاط",
    ov_news: "الأخبار",
    ov_announcements: "الإعلانات",
    ov_announcement: "إعلان",
    ov_membership: "العضوية",
    ov_volunteer: "التطوع",
    ov_business_world: "عالم الأعمال",
    ov_program: "برنامج",
    ov_mission: "الرسالة",
    ov_vision: "الرؤية",

    heading_focus_areas: "مجالات تركيزنا",
    heading_how_to_contribute: "كيف يمكنك المساهمة؟",
    focus_areas_body: "تهدف USEKO في هذا المجال إلى إنتاج أثر مستدام وقابل للقياس ودائم بالتعاون مع الشركاء المحليين والدوليين. تُنفذ جميع أنشطتنا وفق مبادئ الشفافية والمساءلة والإدارة الأخلاقية.",
    contribute_body: "يمكنك دعم مشاريعنا في هذا المجال كمتطوع، عبر شراكة مؤسسية، أو من خلال العضوية.",
    area_contact_heading: "التواصل",
    area_contact_body: "لأي استفسار حول هذا المجال، أو مقترحات التعاون، أو الأفكار المشاريعية، يمكنكم التواصل معنا بسهولة عبر البريد الإلكتروني أدناه.",
    view_projects: "استعرض المشاريع",
    apply_partnership: "طلب شراكة",
    back_to_projects: "العودة إلى المشاريع",
    not_found_title: "الصفحة غير موجودة",
    not_found_body: "الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.",
    back_to_home: "العودة للرئيسية",

    home_activities_title: "أنشطة يوسيكو",
    home_activities_desc: "من الاقتصاد والتجارة إلى الصناعة والتكنولوجيا، ومن الدبلوماسية الثقافية إلى البحث والنشر — نعمل من أجل أثر دائم.",
    home_projects_title: "مشاريع مميزة",
    home_projects_desc: "المشاريع التي نطورها من أجل التنمية المستدامة والفائدة الاجتماعية.",
    home_news_title: "أحدث الأخبار",
    home_announcements_title: "الإعلانات",
    cta_join_desc: "انضم إلى مجتمع USEKO",
    cta_volunteer_desc: "كن جزءاً من الخير",
    cta_partnership_desc: "ابدأ شراكة مؤسسية",

    region_turk_states: "الدول التركية",
    region_balkans: "البلقان",
    region_middle_east: "الشرق الأوسط",
    region_africa: "أفريقيا",
    region_europe: "أوروبا",
    region_global: "الشبكة العالمية",
    region_sub: "التنمية والتعاون",

    about_national_heading: "أنشطتنا الوطنية",
    about_national_body: "نشجع رواد الأعمال على العمل وفق مبادئ الأخلاق العالمية للأعمال؛ ونطور التعاون بين الجامعات والمؤسسات العامة والقطاع الخاص والمنظمات المهنية والمجتمع المدني. نعمل في ريادة الأعمال والاستثمار والتصدير والتحول الرقمي والاقتصاد الأخضر والتنمية المستدامة.",
    about_international_heading: "أنشطتنا الدولية",
    about_international_body: "ننفذ دراسات لتعزيز التنافسية الدولية لمجتمع الأعمال التركي؛ ونقود أنشطة الدبلوماسية العامة والدبلوماسية الاقتصادية والتعاون الدولي. نُنفذ مشاريع التنمية المستدامة في الدول التركية والبلقان والشرق الأوسط وأفريقيا وأوروبا.",
    about_hq_body: "يقع مقر الجمعية في اسطنبول. تُسهم USEKO في تطوير الديمقراطية التشاركية وسيادة القانون والمبادرة الحرة واقتصاد السوق التنافسي والتنمية المستدامة. تُجري أبحاثاً حول التنمية الاقتصادية والاجتماعية لتركيا وتُعِد تقارير وتُسهم في تطوير السياسات العامة.",
    about_focus_heading: "أنشطة يوسيكو",

    mission_hero_desc: "نُسهم في التنمية الاقتصادية والاجتماعية والتكنولوجية لتركيا ونبني المستقبل بالتعاون الدولي.",
    mission_title: "من أجل فائدة دائمة",
    vision_title: "على نطاق دولي",
    aim_overline: "المادة 2 من النظام الأساسي — الأهداف",
    aim_title: "أهدافنا",
    aim_national: "على المستوى الوطني",
    aim_international: "على المستوى الدولي",
    aim_national_items: [
      "تشجيع رواد الأعمال على العمل وفق مبادئ الأخلاق العالمية للأعمال.",
      "الإسهام في تطوير الديمقراطية التشاركية وسيادة القانون والمبادرة الحرة والتنمية المستدامة.",
      "إجراء أبحاث حول التنمية الاقتصادية والاجتماعية لتركيا وإعداد تقارير والإسهام في السياسات العامة.",
      "تطوير التعاون بين الجامعات والمؤسسات العامة والقطاع الخاص والمنظمات المهنية والمجتمع المدني.",
      "العمل في مجالات ريادة الأعمال والاستثمار والتصدير والتحول الرقمي والاقتصاد الأخضر.",
    ],
    aim_international_items: [
      "تعزيز التنافسية الدولية لمجتمع الأعمال التركي.",
      "الإسهام في تطوير العلاقات الاقتصادية والتجارية والثقافية لتركيا.",
      "تنفيذ أنشطة الدبلوماسية العامة والاقتصادية والتعاون الدولي.",
      "تطوير مشاريع في التعليم والصحة والبنية التحتية والتكنولوجيا والبيئة والتنمية الاجتماعية.",
      "تنفيذ مشاريع التنمية المستدامة خاصة في الدول التركية والبلقان والشرق الأوسط وأفريقيا وأوروبا.",
    ],

    // Home — USEKO Purpose section
    home_aim_title: "غرض يوسيكو",
    home_aim_desc: "تأسست الجمعية للإسهام في التنمية الاقتصادية والتجارية والتكنولوجية والعلمية والثقافية والاجتماعية لتركيا؛ ولتعزيز التنافسية المحلية والدولية لرجال الأعمال والمستثمرين والصناعيين الأتراك؛ ودعم التنمية المستدامة؛ وتنفيذ أنشطة الدبلوماسية الاقتصادية؛ وتطوير التعاون الدولي؛ وتنفيذ مشاريع في مجالات التعليم والبحث ونقل التكنولوجيا والابتكار والمساعدات الإنسانية والمسؤولية الاجتماعية.",
    home_aim_national_title: "على المستوى الوطني",
    home_aim_national_items: [
      "أ) تشجيع رواد الأعمال على العمل وفق مبادئ أخلاقيات الأعمال العالمية.",
      "ب) الإسهام في تطوير الديمقراطية التشاركية وسيادة القانون والمبادرة الحرة واقتصاد السوق التنافسي والتنمية المستدامة.",
      "ج) إجراء الأبحاث حول التنمية الاقتصادية والاجتماعية لتركيا وإعداد التقارير والإسهام في تطوير السياسات العامة.",
      "د) تطوير التعاون بين الجامعات والمؤسسات العامة ومنظمات القطاع الخاص والهيئات المهنية ومنظمات المجتمع المدني.",
      "هـ) العمل في مجالات ريادة الأعمال والاستثمار والتصدير والتحول الرقمي والاقتصاد الأخضر والتنمية المستدامة.",
      "و) مشاركة الآراء والمقترحات مع المؤسسات العامة والمنظمات الدولية والرأي العام.",
    ],
    home_aim_international_title: "على المستوى الدولي",
    home_aim_international_items: [
      "أ) تنفيذ الأنشطة اللازمة لتعزيز التنافسية الدولية لمجتمع الأعمال التركي.",
      "ب) الإسهام في تطوير العلاقات الاقتصادية والتجارية والثقافية لتركيا.",
      "ج) تنفيذ أنشطة الدبلوماسية العامة والاقتصادية والتعاون الدولي.",
      "د) تطوير وتنفيذ مشاريع في التعليم والصحة والبنية التحتية والتكنولوجيا والبيئة والتنمية الاجتماعية.",
      "هـ) تنفيذ مشاريع التنمية المستدامة في مناطق متعددة خاصةً الدول التركية والبلقان والشرق الأوسط وأفريقيا وأوروبا.",
      "و) العمل المشترك مع المؤسسات العامة والمنظمات الدولية والجامعات ووكالات التنمية ومؤسسات الاستثمار وممثلي القطاع الخاص.",
    ],

    principles_desc: "قيمنا الأساسية التي تشكل أنشطتنا.",
    documents_desc: "النظام الأساسي للجمعية وتقارير الأنشطة والوثائق الرسمية.",
    documents_empty: "لم يتم نشر أي وثائق بعد. قريباً هنا.",
    board_desc: "أعضاء مجلس إدارة USEKO ومناصبهم.",
    news_hero_desc: "أحدث الأخبار والأنشطة والبرامج من USEKO.",
    announcements_hero_desc: "أحدث إعلانات وتحديثات USEKO.",

    filter_all_status: "جميع الحالات",
    project_categories: {
      "": "الكل",
      economy: "الاقتصاد والتجارة",
      industry: "الصناعة والتكنولوجيا",
      education: "التعليم والأكاديمي",
      social: "التنمية الاجتماعية",
      culture: "الدبلوماسية الثقافية",
      research: "البحث والنشر",
    },
    project_status_labels: {
      "": "جميع الحالات",
      planned: "مخطط",
      ongoing: "جاري",
      completed: "منجز",
    },

    detail_category: "الفئة",
    detail_country: "البلد",
    detail_city: "المدينة",
    detail_start: "البداية",
    detail_end: "النهاية",
    detail_status: "الحالة",

    mtype_individual: "عضو فردي",
    mtype_corporate: "عضو مؤسسي",
    mtype_volunteer: "عضو متطوع",
    mtype_supporter: "عضو داعم",

    ptype_project: "شراكة مشاريع",
    ptype_sponsorship: "رعاية",
    ptype_support: "دعم مؤسسي",
    ptype_trade: "تعاون تجاري واستثماري",
    ptype_research: "بحث وأكاديمي",
    ptype_b2b: "لقاء أعمال B2B",
    ptype_diplomatic: "دبلوماسية عامة/اقتصادية",

    vfield_education: "التعليم",
    vfield_research: "البحث",
    vfield_trade: "التجارة/الاقتصاد",
    vfield_logistics: "اللوجستيات",
    vfield_social_media: "وسائل التواصل",
    vfield_translation: "الترجمة",
    vfield_field: "العمل الميداني",
    vfield_organization: "التنظيم",
    vfield_data: "إدخال البيانات",

    iarea_economy: "الاقتصاد والتجارة",
    iarea_industry: "الصناعة والتكنولوجيا والدفاع",
    iarea_education: "التعليم والأكاديمي",
    iarea_social: "التنمية الاجتماعية",
    iarea_culture: "الدبلوماسية الثقافية",
    iarea_research: "البحث والنشر",
    iarea_financial: "الأنشطة المالية والتجارية",
    iarea_volunteer: "التطوع",

    day_mon: "اثن", day_tue: "ثلا", day_wed: "أرب", day_thu: "خمي",
    day_fri: "جمع", day_sat: "سبت", day_sun: "أحد",

    contact_addr_line: "اسطنبول، تركيا",
    contact_addr_label: "العنوان",
    contact_phone_label: "الهاتف",
    contact_email_label: "البريد الإلكتروني",
    footer_credit_prefix: "تم تطوير هذا الموقع بواسطة",
    footer_credit_suffix: ".",

    act_bullets: {
      "ekonomi-ticaret": [
        "منظمات التجارة والاستثمار الدولية",
        "تطوير الأعمال واستشارات الاستثمار",
        "أبحاث السوق والتحليلات القطاعية",
        "دعم وصول الشركات التركية إلى الأسواق الدولية",
        "المعارض والوفود ولقاءات B2B",
        "التوجيه في عمليات التصدير والاستثمار",
      ],
      "sanayi-teknoloji-savunma": [
        "مشاريع تطوير التكنولوجيا والابتكار",
        "التحول الرقمي والذكاء الاصطناعي",
        "شراكات الأمن السيبراني",
        "التعاون الدولي في الصناعة الدفاعية",
        "البحث والتطوير ونقل التكنولوجيا",
        "الصناعة 4.0 والتصنيع الذكي",
      ],
      "egitim-akademik": [
        "برامج تدريبية وندوات ومؤتمرات وورش عمل",
        "أبحاث مشتركة مع الجامعات",
        "برامج المنح والتبادل الأكاديمي",
        "مشاريع التدريب المهني",
        "برامج الشباب والقيادة",
        "التعاون الأكاديمي الدولي",
      ],
      "sosyal-kalkinma": [
        "مشاريع المساعدات الاجتماعية والإنسانية",
        "مشاركة النساء في الحياة الاقتصادية",
        "دعم الشباب والفئات المحرومة",
        "إسهامات إعادة الإعمار بعد الكوارث",
        "برامج التنمية المحلية",
        "مبادرات التضامن المجتمعي",
      ],
      "kulturel-diplomasi": [
        "الفعاليات الثقافية الدولية",
        "المعارض والمهرجانات ومنظمات الترويج",
        "الترويج الدولي للتراث الثقافي التركي",
        "برامج التبادل الثقافي",
        "شراكات الفن والثقافة",
        "مبادرات الدبلوماسية العامة",
      ],
      "arastirma-yayin": [
        "التقارير البحثية وأوراق السياسات",
        "الدوريات والكتب",
        "منصات النشر الرقمي",
        "الدراسات الأكاديمية والميدانية",
        "التحليلات القطاعية",
        "المشاركة العامة للمعرفة",
      ],
      "mali-ticari": [
        "تأسيس المؤسسات الاقتصادية",
        "تأسيس الشركات والشراكات",
        "اكتساب الأصول المنقولة وغير المنقولة",
        "إدارة المنح والصناديق",
        "الوصول إلى الصناديق الوطنية والدولية",
        "تأسيس الأوقاف والتعاون",
      ],
    },

    legal_kvkk_intro: "بموجب قانون حماية البيانات الشخصية رقم 6698 (KVKK)، تتم معالجة بياناتك الشخصية التي تجمعها USEKO لتقييم طلبك والتواصل معك.",
    legal_privacy_intro: "تلتزم USEKO بحماية خصوصية المستخدم.",
    legal_cookies_intro: "يستخدم موقعنا ملفات تعريف الارتباط للوظائف الأساسية والتحليلات والتسويق.",
    legal_terms_intro: "يخضع استخدام هذا الموقع لشروط استخدام USEKO.",
  },
};

export const availableLanguages = [
  { code: "tr", name: "TR" },
  { code: "en", name: "EN" },
  { code: "ar", name: "AR" },
];
